export interface ThemeInfo { id: string; label: string; en: string; accent: string; displayName: string; background: string }
export function skinValue(value: number) {
  const tier = Math.max(1, Math.round(Math.log2(Math.max(2, value))));
  return 2 ** ((tier - 1) % 15 + 1);
}
export function valueLabel(value: number) {
  if (value <= 8192) return String(value);
  if (value < 1024 ** 2) return value / 1024 + 'K';
  if (value < 1024 ** 3) return value / 1024 ** 2 + 'M';
  return value / 1024 ** 3 + 'G';
}
